export enum ListingSortColumn {
	MLID = "Listing_ID",
	MEMBER_NAME = "ListMember.MemberLastName,ListMember.MemberFirstName",
	STATUS_NAME = "ListingStatus_CD",
	CITY_NAME = "City.CityName",
	PRICE = "Listing.ListPrice_AMT,Listing.LeasePrice_AMT",
	DATE = "ListingContract_DT",
	EXPIRATION = "Expiration_DT",
	MODIFICATION = "Listing.ModificationTimestamp_UTCDTTM",
}
